import firebase from '../../firebase';

export default async function getUsers(params) {
    const users = await firebase.functions().httpsCallable('search-users')(params);
    if (users && users.data) {
        return users.data;
    }
    return {};
}
